<template>
  <div id="verify-tree-grid" class="grid-view">
    <cargo-up-down-resize
      class="app-main-inner section"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: '5px'}"
      :down-style="{display: 'flex', flexDirection: 'column', paddingTop: '5px'}"
      :show-up="showAr"
      style="height: 100%"
    >
      <template slot="up">
        <div style="align-items: center; display: flex">
          <div style="">
            <span>{{ $t('CargoMsg.Cargo_Receivable') }}</span>
          </div>
          <div style="padding-left: 5px">
            <!--新增费用-->
            <el-button
              id="btnAdd1"
              type="primary"
              :disabled="!isEditing"
              @click="addCost"
            >{{ $t('FinanceManage.charge_add') }}
            </el-button>
            <!--费用删除-->
            <el-button
              id="btnDelete1"
              type="danger"
              :disabled="!isEditing"
              @click="deleteCost()"
            >{{ $t('FinanceManage.charge_delete') }}
            </el-button>
          </div>
        </div>
        <cargo-ag-grid
          ref="arGrid"
          :grid-options="ar.gridOptions"
          :column-defs="ar.columnDefs"
          config-module="250319"
          :row-data="ar.rowData"
          style="padding-top: 5px"
          @gridReady="p=> {ar.gridApi = p.api}"
        />
      </template>
      <template slot="down">
        <div style="display: flex;align-items: center;">
          <div>
            <span>{{ $t('CargoMsg.Cargo_Dues') }}</span>
          </div>
          <div style="padding-left: 5px">
            <!--新增费用-->
            <el-button
              id="btnAdd1"
              type="primary"
              :disabled="!isEditing"
              @click="addSelling"
            >{{ $t('FinanceManage.charge_add') }}
            </el-button>
            <!--费用删除-->
            <el-button
              id="btnDelete1"
              type="danger"
              :disabled="!isEditing"
              @click="deleteSelling"
            >{{ $t('FinanceManage.charge_delete') }}
            </el-button>
          </div>
        </div>
        <cargo-ag-grid
          ref="apGrid"
          :grid-options="ap.gridOptions"
          :column-defs="ap.columnDefs"
          config-module="250320"
          :row-data="ap.rowData"
          style="padding-top: 5px"
          @gridReady="p=> {ap.gridApi = p.api}"
        />
      </template>
    </cargo-up-down-resize>
  </div>
</template>
<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize.vue'
import ColumnUtils from '@/utils/ColumnUtils'
import CustomLabelUtils from '@/utils/CustomLabelUtils'
import { chargeItemCompatibleLanguage } from '@/utils/commonUtil'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor/index.vue'
import { Charge } from '@/class/model/act/Charge'
import DateUtils from '@/utils/dateUtils'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index.vue'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { getUuid } from '@/utils'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import { getLoading } from '@/utils/utilBaseElement'
import { warehouseInCharge } from '@/api/warehouseIn/warehouseIn'
import {
  CHARGE_FRONT_WAREHOUSE,
  CHARGE_FRONT_WAREHOUSE_SYNCHRONIZE
} from '@/class/cargo/model/parameters/SystemConstants'

export default {
  name: 'TabWarehousingCharge',
  components: { cargoUpDownResize },
  props: {
    warehouseInUuid: { type: String, default: () => '' },
    action: { type: String, default: () => '' },
    showAr: { type: Boolean, default: () => true }
  },
  data() {
    return {
      localCurrency: '',
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        customerTitlesMap: new Map(), // 委托单位和关联的发票抬头
        chargeItemArray: [],
        currencyArray: []
      },
      selectTypeNames: TYPE_NAMES,
      warehouseInInfo: null,
      ar: {
        key: 'addTabCost__',
        configModule: '250319',
        gridApi: null,
        rowData: [],
        deleteUuids: [],
        gridParams: {},
        gridOptions: {
          singleClickEdit: true,
          rowSelection: 'multiple',
          suppressCellSelection: true,
          selectedRowIndex: -1,
          context: {
            componentParent: this
          },
          getRowStyle: (params) => {
            if (!params.data) {
              return {}
            }
            const chargeData = params.data
            const rowStyle = {}
            if (chargeData.chargeSource === CHARGE_FRONT_WAREHOUSE_SYNCHRONIZE.code) {
              Object.assign(rowStyle, { background: '#999999' })
            }
            return rowStyle
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonTextareaEditor
          },
          columnApi: null
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('FinanceManage.charge_chargeItem'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'chargeItemId',
            field: 'chargeItemId',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
            },
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => {
              return {
                selectProps: {
                  staticOptions: [...this.currentViewCacheData.chargeItemArray],
                  tagValue: 'itemId',
                  tagName: this.language ? 'zhName' : 'enName',
                  filterable: true,
                  filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
                  filterType: 'global',
                  customLabel: (item) => this.chargeItemLanguageName(item, this.language),
                  showCustomLabelInOption: true
                }
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'accountId',
            field: 'accountId',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId', false)
            },
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Company,
                tagValue: 'cmpIdx',
                tagName: 'chineseName',
                methodParams: { active: true },
                autoKey: 'auto_accountId',
                receivable: false,
                dataFilterFunction: (item, inputVal) => {
                  if (item.cmpIdx === inputVal) {
                    return true
                  }
                  if (item.ifSupplier) {
                    return true
                  }
                  return false
                },
                filterable: true
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_invoiceHeader'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'invoiceTitle',
            field: 'invoiceTitle',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => ({
              selectProps: {
                tagValue: 'invoiceTitle',
                tagName: 'invoiceTitle',
                allowCreate: true,
                staticOptions: this.getInvoiceTitleList(params.data.accountId),
                filterable: true,
                filterTagNames: ['invoiceTitle'],
                filterType: 'global'
              }
            }),
            initialHide: false,
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
            headerClass: 'ag-header-cell-center',
            cellStyle: {
              textAlign: 'center'
            },
            editable: (params) => this.isRowEdit(params.data),
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => {
              return {
                selectProps: {
                  tagValue: 'code',
                  tagName: 'code',
                  staticOptions: [...this.currentViewCacheData.currencyArray],
                  filterable: true,
                  filterTagNames: ['code']
                }
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_exchangeRate'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'exchangeRate',
            field: 'exchangeRate',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.value).format('0.00000000')
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.value).format('0.00')
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 2
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true,
            summaryMode: 'sum'
          },
          {
            headerName: this.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            editable: (params) => this.isRowEdit(params.data),
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            enableRowGroup: true
          }
        ]
      },
      ap: {
        key: 'addTabSelling__',
        configModule: '250320',
        gridApi: null,
        rowData: [],
        deleteUuids: [],
        gridParams: {},
        gridOptions: {
          singleClickEdit: true,
          rowSelection: 'multiple',
          suppressCellSelection: true,
          selectedRowIndex: -1,
          context: {
            componentParent: this
          },
          getRowStyle: (params) => {
            if (!params.data) {
              return {}
            }
            const chargeData = params.data
            const rowStyle = {}
            if (chargeData.chargeSource === CHARGE_FRONT_WAREHOUSE_SYNCHRONIZE.code) {
              Object.assign(rowStyle, { background: '#999999' })
            }
            return rowStyle
          },
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridAdvanceSelectEditor,
            CargoAgGridCommonTextareaEditor
          },
          columnApi: null
        },
        columnDefs: [
          {
            headerName: '', width: 55, checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('FinanceManage.charge_chargeItem'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'chargeItemId',
            field: 'chargeItemId',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return ColumnUtils.resolveColumnLabelChargeItemLanguage(TYPE_NAMES.basic_data_ChargeItem, 'itemId', Number(params.value), 'zhName')
            },
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => {
              return {
                selectProps: {
                  staticOptions: [...this.currentViewCacheData.chargeItemArray],
                  tagValue: 'itemId',
                  tagName: this.language ? 'zhName' : 'enName',
                  filterable: true,
                  filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
                  filterType: 'global',
                  customLabel: (item) => this.chargeItemLanguageName(item, this.language),
                  showCustomLabelInOption: true
                }
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_settleAccountsTo'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'accountId',
            field: 'accountId',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              return CustomLabelUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'auto_accountId', false)
            },
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: {
              selectProps: {
                selectType: TYPE_NAMES.basic_data_Company,
                tagValue: 'cmpIdx',
                tagName: 'chineseName',
                methodParams: { active: true },
                autoKey: 'auto_accountId',
                receivable: false,
                dataFilterFunction: (item, inputVal) => {
                  if (item.cmpIdx === inputVal) {
                    return true
                  }
                  if (item.ifSupplier) {
                    return true
                  }
                  return false
                },
                filterable: true
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_invoiceHeader'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'invoiceTitle',
            field: 'invoiceTitle',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => ({
              selectProps: {
                tagValue: 'invoiceTitle',
                tagName: 'invoiceTitle',
                allowCreate: true,
                staticOptions: this.getInvoiceTitleList(params.data.accountId),
                filterable: true,
                filterTagNames: ['invoiceTitle'],
                filterType: 'global'
              }
            }),
            initialHide: false,
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_currency'), colId: 'currency', field: 'currency', initialWidth: 180,
            headerClass: 'ag-header-cell-center',
            cellStyle: {
              textAlign: 'center'
            },
            editable: (params) => this.isRowEdit(params.data),
            cellEditor: 'CargoAgGridAdvanceSelectEditor',
            cellEditorParams: (params) => {
              return {
                selectProps: {
                  tagValue: 'code',
                  tagName: 'code',
                  staticOptions: [...this.currentViewCacheData.currencyArray],
                  filterable: true,
                  filterTagNames: ['code']
                }
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_exchangeRate'),
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            colId: 'exchangeRate',
            field: 'exchangeRate',
            initialWidth: 180,
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.value).format('0.00000000')
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true
          },
          {
            headerName: this.$t('FinanceManage.charge_taxIncludedPrice'), colId: 'amount', field: 'amount', initialWidth: 180,
            headerClass: 'ag-header-cell-right',
            cellStyle: {
              textAlign: 'right'
            },
            editable: (params) => this.isRowEdit(params.data),
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.value).format('0.00')
            },
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 2
              }
            },
            onCellValueChanged: p => this.onCellChange(p),
            enableRowGroup: true,
            summaryMode: 'sum'
          },
          {
            headerName: this.$t('FinanceManage.charge_remarks'), colId: 'remarks', field: 'remarks', initialWidth: 180,
            headerClass: 'ag-header-cell-left',
            cellStyle: {
              textAlign: 'left'
            },
            editable: (params) => this.isRowEdit(params.data),
            cellEditor: 'CargoAgGridCommonTextareaEditor',
            enableRowGroup: true
          }
        ]
      }
    }
  },
  computed: {
    readonly() {
      return !this.isEditing
    },
    isEditing() {
      return this.action !== 'look'
    }
  },
  watch: {
  },
  mounted() {},
  methods: {
    async onShow(action, refresh) {
      await cache.load(cacheName.CONFIG)
      await this.initChargeItemSet()
      await this.initCurrencySet()
      this.localCurrency = await RateUtil.localCurrencyByOfficeIdSync(this.$store.getters.currentOfficeId)
      this.action = action
      if (this.action === 'add' && refresh) {
        this.$emit('refreshHandler')
        this.ar.rowData = []
        this.ap.rowData = []
        this.refreshCellData()
      } else {
        if (refresh) {
          this.handleGetWarehouseInCharge()
        }
      }
    },
    handleGetWarehouseInCharge() {
      this.loading = getLoading()
      const { warehouseInUuid } = this
      warehouseInCharge({ uuid: warehouseInUuid })
        .then((res) => {
          this.$emit('refreshHandler')
          const charges = res.data
          this.ar.rowData = charges.filter(p => p.receivable)
          this.ap.rowData = charges.filter(p => !p.receivable)
          this.refreshCellData()
        })
      this.loading.close()
    },
    getSubmitData() {
      const charges = []
      for (const arC of this.ar.rowData) {
        if (arC.uuid.includes(this.ar.key)) {
          arC.uuid = ''
        }
        charges.push(arC)
      }
      for (const apC of this.ap.rowData) {
        if (apC.uuid.includes(this.ap.key)) {
          apC.uuid = ''
        }
        charges.push(apC)
      }
      const delChargeUuids = [...this.ar.deleteUuids, ...this.ap.deleteUuids]
      // 返回深拷贝的 this.form，避免外部修改影响原始数据
      return {
        charges,
        delChargeUuids
      }
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      // 将 Set 转换为数组
      const chargeItemArray = Array.from(results)
      const filter = { airExport: true, active: true }
      // 过滤出符合 filter 条件的对象
      chargeItemArray.filter(item => {
        // 使用 every 方法检查 item 是否包含 demo 中的所有属性，并且值相等
        return Object.keys(filter).every(key => item[key] === filter[key])
      })
      this.currentViewCacheData.chargeItemArray = chargeItemArray
    },
    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currentViewCacheData.currencyArray = Array.from(results)
    },
    deleteCost() {
      const chooseRows = this.ar.gridApi.getSelectedRows()
      for (const charge of chooseRows) {
        if (!this.isRowEdit(charge)) {
          this.$message.warning(this.$t('Message.ThereAreFeesCantBeDeletedPleaseRecheck'))
          return
        }
        charge.deleted = true
        charge.otherUuid = this.warehouseInUuid
        const index2 = this.ar.rowData.indexOf(charge)
        this.ar.rowData.splice(index2, 1)
        if (charge.uuid && !charge.uuid.startsWith(this.ap.key) && !charge.uuid.startsWith(this.ar.key)) {
          this.ar.deleteUuids.push(charge.uuid)
        }
      }
    },
    isRowEdit(charge) {
      if (!this.isEditing) {
        return false
      }
      if (charge.chargeSource === CHARGE_FRONT_WAREHOUSE_SYNCHRONIZE.code) {
        return false
      }
      return true
    },
    deleteSelling() {
      const chooseRows = this.ap.gridApi.getSelectedRows()
      for (const charge of chooseRows) {
        if (!this.isRowEdit(charge)) {
          this.$message.warning(this.$t('Message.ThereAreFeesCantBeDeletedPleaseRecheck'))
          return
        }
        charge.deleted = true
        charge.otherUuid = this.warehouseInUuid
        const index2 = this.ap.rowData.indexOf(charge)
        this.ap.rowData.splice(index2, 1)
        if (charge.uuid && !charge.uuid.startsWith(this.ap.key) && !charge.uuid.startsWith(this.ar.key)) {
          this.ap.deleteUuids.push(charge.uuid)
        }
      }
    },
    async addCost() {
      await this.addCharge(true)
    },
    async addSelling() {
      await this.addCharge(false)
    },
    async addCharge(receivable) {
      const obj = new Charge().fillDefaultValue().getData()
      obj.receivable = receivable
      if (receivable) {
        obj.uuid = this.ar.key + getUuid()
        this.ar.rowData.push(obj)
      } else {
        obj.uuid = this.ap.key + getUuid()
        this.ap.rowData.push(obj)
      }
      const office = this.$store.getters.currentOffice
      obj.branchId = office.officeId
      obj.inputBy = this.$store.getters.userId
      obj.inputDate = DateUtils.formatStandardDateTime(new Date())
      obj.localCurrency = this.localCurrency
      obj.currency = obj.oversea ? 'USD' : this.localCurrency
      obj.exchangeRate = 1
      obj.exchangeRate = await RateUtil.getForeignExchangeRateByDate(this.localCurrency, obj.currency, obj.inputDate, obj.branchId, function(rate) {
        obj.exchangeRate = rate
      })
      obj.quantity = 1
      obj.unitRate = 0
      obj.amount = 0
      obj.measure = this.getMeasureData()
      // HQ币种/汇率
      obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
      obj.hqRate = await RateUtil.getForeignExchangeRateByDate(obj.hqCurrency, this.localCurrency, obj.inputDate, obj.branchId)
      obj.taxAmount = 0
      obj.excludingTaxAmount = 0
      obj.verifiedAmount = 0
      obj.taxRate = 0
      obj.accountingDate = null
      obj.counterPartyBillingNo = null
      obj.chargeSource = CHARGE_FRONT_WAREHOUSE.code
      obj.chargeState = 0
      obj.otherUuid = this.warehouseInUuid
      obj.accountId = Number(obj.accountId) > 0 ? Number(obj.accountId) : 0

      await this.getTitlesByCompanyId(obj)
    },
    getMeasureData() {
      const l = getCacheListByKey(basicCacheKeys.basic_data_ChargeUnit)
      let measure = ''
      for (const item of l) {
        if (item && item.ifDefault && item.unit) {
          measure = item.code
        }
      }
      return measure
    },
    chargeItemLanguageName(item, viewLanguage) {
      let languageName = item.zhName
      if (!viewLanguage) {
        // 费用项uuuid
        const uuid = item.uuid
        // 根据费用项uuid获取对应的语言配置列表
        const chargeItemLanguages = getFilterCacheList(TYPE_NAMES.basic_data_ChargeItemLanguage, (item) => {
          return item.chargeItemUuid === uuid
        })
        const office = this.$store.getters.currentOffice
        chargeItemLanguages.forEach(chargeItemLanguage => {
          if (office.region && office.region === chargeItemLanguage.regionCode) {
            languageName = chargeItemLanguage.chargeLanguage
          }
        })
      }
      return viewLanguage ? `${item.zhName}[${item.enName}]` : `${item.enName}[${languageName}]`
    },
    getInvoiceTitleList(accountId) {
      if (this.currentViewCacheData.customerTitlesMap.get(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    },
    async getTitlesByCompanyId(charge) {
      const accountId = charge.accountId
      if (!accountId || accountId <= 0) return
      if (this.currentViewCacheData.customerTitlesMap.has(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId)
      }
      // 获取数据库中维护的开票抬头
      const res = await queryTitleByCpmIdx(accountId)
      let dbTitles = res.data
      if (!dbTitles) dbTitles = []
      if (dbTitles.length > 0) {
        for (const title of dbTitles) {
          if (!title.title) continue
          title.invoiceTitle = title.title
        }
      }
      this.currentViewCacheData.customerTitlesMap.set(accountId, dbTitles)
      return this.currentViewCacheData.customerTitlesMap.get(accountId)
    },

    async onCellChange(params) {
      console.log('cellChange', params)
      const charge = params.data
      // 加载开票抬头
      await this.getTitlesByCompanyId(charge)
      // 设置开票抬头
      await ChargeUtils.updateDefaultInvoiceTitle([charge])
      const newParams = {
        rowIndex: params.node.rowIndex,
        colId: params.column.colId,
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        originalValue: params.oldValue
      }
      charge.unitRate = charge.amount
      const job = {}
      job.lob = 'AE'
      job.etd = new Date()
      switch (params.colDef.field) {
        case 'currency': {
          await ChargeColumnUtil.currencyChangeHandler(charge, job)
          break
        }
        case 'amount': {
          await ChargeColumnUtil.amountChange(charge, newParams)
          break
        }
      }
      this.refreshCellData()
    },
    refreshCellData() {
      this.ar.gridOptions.api.refreshCells({ force: true })
      this.ap.gridOptions.api.refreshCells({ force: true })
    }
  }
}
</script>

<style lang="scss">

</style>
